// extracted by mini-css-extract-plugin
export default {"valuesContainer":"valuesContainer---rMrTG","ItemWrapper":"ItemWrapper---YyOh2","ItemWrapper--dragging":"ItemWrapper--dragging---si0xV","dragBtn":"dragBtn---WLBOp"};